{
  "en": {
    "partners": {
      "headings": {
        "course": "Start your professional development with {partner}",
        "description": "That is why we recommend {partner}:",
        "emptyState": "Sorry, no English partner entries were found.",
        "feedback": "Is your favorite tool missing or would you like to recommend an application?",
        "materials": "Find teaching material by {partner}",
        "subtitle": "What would you like to use today?",
        "title": "Get to know selected partners in education"
      },
      "hints": {
        "notPublished": "This partner is not yet published. Only visible for admins. 😎"
      },
      "links": {
        "breadCrumbIndex": "All Partners",
        "login": "Login",
        "loginWithFobizz": "Log in now with fobizz",
        "registerWithFobizz": "Try for free with fobizz",
        "sendFeedback": "Please send us an e-mail to"
      }
    }
  }
}
